import {Injectable} from '@angular/core';
import {CreatedByModel} from 'spotcharge-types';

@Injectable({
  providedIn: 'root'
})
export class ContextProvider {

  private user: CreatedByModel;
  private currencyCode: string;

  constructor() {
  }

  storeUserData(user: CreatedByModel) {
    this.user = {id: user.id, name: user.name};
  }

  getUser() {
    return this.user;
  }

  storeCurrency(currencyCode: string) {
    this.currencyCode = currencyCode;
  }
  getCurrency() {
    return this.currencyCode || 'INR';
  }

}
